// extracted by mini-css-extract-plugin
export default {"container":"Videos_container__0ge23","normal":"Videos_normal__9yqwg","video":"Videos_video__ihcmN"};